export default "__VITE_ASSET__DiYiW10H__"